

jQuery(function(){
  // voeg viewport class toe aan body
  function setviewportclass() {
    // eslint-disable-next-line max-len
    var viewport = window.getComputedStyle(document.querySelector('body'), ':after').getPropertyValue('content')
  .replace(/['"]+/g, '');
    jQuery('html').addClass(viewport);
  }

  setviewportclass();

  jQuery(window).resize(function() {
    jQuery('html').removeClass('br-default');
    jQuery('html').removeClass('br-small');
    jQuery('html').removeClass('br-medium');
    jQuery('html').removeClass('br-large');
    setviewportclass();
  });
});